import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterCustomer'
})
export class FilterCustomerPipe implements PipeTransform {

  transform(items: any[], searchText: string): any[] {
    if(!items) return [];
    if(!searchText) return items;
searchText = searchText.toLowerCase();
return items.filter( it => {
      let invoice_num = it.invoice_num == null? "": it.invoice_num;
      return it.cust_name.toLowerCase().includes(searchText.toLowerCase())||invoice_num.toLowerCase().includes(searchText.toLowerCase());
    });
   }

}
